<template>
    <div class="roadmap-steps-content apprentice-simple-card">
        <design-2021-roadmap-step-header-component></design-2021-roadmap-step-header-component>

        <design-2021-roadmap-edit-steps-details-component
            :roadmap-in="roadmapIn"></design-2021-roadmap-edit-steps-details-component>

        <div class="new-page-container">
            <b-button
                class="btn-add"
                v-b-modal="'roadmap-step-title-add-modal'"
                variant="primary">
                {{ $t('roadmap.add_new_step') }}
            </b-button>

            <design-2021-roadmap-step-add-title-modal-component
                :roadmap-in="roadmapIn"></design-2021-roadmap-step-add-title-modal-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-roadmap-edit-steps-component',
    props: ['roadmapIn'],
    methods: {
        addStep() {
            const data = {
                roadmap_id: this.roadmapIn.id,
            };

            this.alert.saving();
            this.axios.post(this.routes.roadmapStepCreate(), data).then(
                (response) => {
                    this.roadmapIn.addRelation('steps', response.data.step);

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.new-page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
